<template>
  <svg
    viewBox="0 547.59 1920 125"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m1919.97 613.87c-91.24-38.57-177.99-57.86-260.24-57.86-121.45 0-144.22 105.36-406.08 105.31-4.16 0-8.37-.03-12.65-.08-273.81-3.5-320.33-102.5-579-47.37s-287.74-7.04-425.09-49.13c-91.57-28.05-170.54-11.68-236.91 49.13v58.72h1920v-99.08zm-1919.97-66.28v66.28l.04-66.28z"
    />
  </svg>
</template>
